import { GroupingState } from './state';
import { CHANGE_GROUPBY, ChangeGroupBy, COLLAPSE_GROUPBY, CollapseGroupBy } from './types';

export function changeGroupBy(group: GroupingState): ChangeGroupBy {
    return {
        type: CHANGE_GROUPBY,
        payload: group
    };
}

export function collapseGroups(): CollapseGroupBy {
    return {
        type: COLLAPSE_GROUPBY
    };
}
